import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierList extends Layout {
    btnAddCarrier: Button;
    labelPageTitle: Label;
    sourceCarrier: DataSource;
    sourceCarrierInsCtrl: DataSource;
    table1: Table;
}
